export const PRODUCT = {
    GET_PRODUCT_VACATION: "product/GET_PRODUCT_VACATION"
}

  